import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20Asian%20travel%20destinations%20collage%20with%20tropical%20islands%20ancient%20temples%20mountain%20landscapes%20and%20modern%20cityscapes%20warm%20golden%20sunlight%20dramatic%20sky%20vibrant%20colors%20cinematic%20composition%20peaceful%20atmosphere&width=1800&height=900&seq=hero-bg-asia-2025&orientation=landscape"
        alt="亚洲旅行目的地全景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight max-w-3xl">
          探索亚洲最美的旅行目的地
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-xl mb-6 md:mb-8 leading-relaxed">
          从热带海岛到古都文化，从山川秘境到都市风情，亚洲天堂带您发现令人心动的旅途
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/tropical-islands"
            className="px-6 py-2.5 md:px-8 md:py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm md:text-base font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-6 py-2.5 md:px-8 md:py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white text-sm md:text-base font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/30"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}